import * as types from './types';

export const getMainIncome = () => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(beginFetchMainIncome());

    MPWWebApi.getGeneric('MainIncome')
      .then(response => {
        dispatch({
          type: types.INCOMEBRACKET_MAININCOME_GET,
          payload: response.data,
        });
        dispatch(endFetchMainIncome());
      })
      .catch(error => {
        dispatch({
          type: types.INCOMEBRACKET_ERROR,
          payload: error,
        });
        dispatch(endFetchMainIncome());
      });
  };
};

const beginFetchMainIncome = () => {
  return {
    type: types.INCOMEBRACKET_MAININCOME_BEGIN_FETCH,
  };
};

const endFetchMainIncome = () => {
  return {
    type: types.INCOMEBRACKET_MAININCOME_END_FETCH,
  };
};

export const getIncomeBracket = id => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(beginFetch());

    const method = `mainincome/${id}/incomebracket`;

    MPWWebApi.getGeneric(method)
      .then(response => {
        dispatch({
          type: types.INCOMEBRACKET_GET,
          payload: response.data,
        });
        dispatch(endFetch());
      })
      .catch(error => {
        dispatch({
          type: types.INCOMEBRACKET_ERROR,
          payload: error,
        });
        dispatch(endFetch());
      });
  };
};

export const getCurrentIncomeBracket = () => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(beginFetch());

    const method = `mainincome/incomebracket/current`;

    MPWWebApi.getGeneric(method)
      .then(response => {
        dispatch({
          type: types.INCOMEBRACKET_GET,
          payload: response.data,
        });
        dispatch(endFetch());
      })
      .catch(error => {
        dispatch({
          type: types.INCOMEBRACKET_ERROR,
          payload: error,
        });
        dispatch(endFetch());
      });
  };
};

const beginFetch = () => {
  return {
    type: types.INCOMEBRACKET_BEGIN_FETCH,
  };
};

const endFetch = () => {
  return {
    type: types.INCOMEBRACKET_END_FETCH,
  };
};

export const postCreateUpdate = (fiscalYear, type, incomeId) => {
  return (dispatch, getState, MPWWebApi) => {
    type === 'UPDATE'
      ? dispatch(beginFetchUpdate())
      : dispatch(beginFetchCreate());

    MPWWebApi.postGenericInsertUpdate(`mainincome/create/${fiscalYear}`)
      .then(response => {
        dispatch({
          type: types.INCOMEBRACKET_CREATE,
          payload: response.data,
        });
        dispatch(getMainIncome());
        dispatch(getCanCreateNew());
        dispatch(getIncomeBracket(incomeId));
        type === 'UPDATE'
          ? dispatch(endFetchUpdate())
          : dispatch(endFetchCreate());
      })
      .catch(error => {
        dispatch({
          type: types.INCOMEBRACKET_ERROR,
          payload: error.response.data,
        });
        type === 'UPDATE'
          ? dispatch(endFetchUpdate())
          : dispatch(endFetchCreate());
      });
  };
};

const beginFetchUpdate = () => {
  return {
    type: types.INCOMEBRACKET_BEGIN_UPDATE_FETCH,
  };
};

const endFetchUpdate = () => {
  return {
    type: types.INCOMEBRACKET_END_UPDATE_FETCH,
  };
};

const beginFetchCreate = () => {
  return {
    type: types.INCOMEBRACKET_BEGIN_CREATE_FETCH,
  };
};

const endFetchCreate = () => {
  return {
    type: types.INCOMEBRACKET_END_CREATE_FETCH,
  };
};

export const getCanCreateNew = () => {
  return (dispatch, getState, MPWWebApi) => {
    MPWWebApi.getGeneric('mainincome/CanCreateNew')
      .then(response => {
        dispatch({
          type: types.INCOMEBRACKET_POST_CANCREATE,
          payload: response.data,
        });
      })
      .catch(error => {
        dispatch({
          type: types.INCOMEBRACKET_ERROR,
          payload: error,
        });
      });
  };
};



// WEBPACK FOOTER //
// ./src/pages/incomebracket/state/actions.js